module.exports = __webpack_public_path__ + "img/section-title-bg.d2dc9a89.png";